import { InmateHistory } from '@reliance/types/models/InmateHistory';
import { useAsync } from 'react-async-hook';
import api from '../common/api';

export const useInmateHistoryByInmateId = (inmateId: number | null | undefined) => {
  return useAsync<InmateHistory[]>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }
      return api
        .get<InmateHistory[] | { data: InmateHistory[] }>('/inmate-history', {
          params: { inmateId: id, orderBy: '-dateChanged' },
        })
        .then((r) => {
          const body = r.data;
          return Array.isArray(body) ? body : (body?.data ?? []);
        });
    },
    inmateId === null ? [] : [inmateId]
  );
};
